import { z } from 'zod';
import { RevisionStatus } from 'libs/end-to-end/src/types/databases/revisions/revision-status';
import { FullDatabaseRevisionSchema } from 'libs/end-to-end/src/types/databases/revisions/database-revision-schema';

export const DatabaseRevision = z.object({
  id: z.string(),
  sequence: z.number(),
  revisionStatus: RevisionStatus,
  publishError: z.unknown().optional(),
  publishUserId: z.string().optional(),
  transformId: z.string().nullable(),
  selectedSchema: FullDatabaseRevisionSchema.nullable(),
  name: z.string().optional(),
  createdDate: z.string().optional().nullable(),
  publishDate: z.string().optional().nullable(),
  isHidden: z.boolean().optional(),
});

export type DatabaseRevision = z.infer<typeof DatabaseRevision>;

export const DatabaseRevisionForPatch = DatabaseRevision.pick({
  transformId: true,
  selectedSchema: true,
  name: true,
  isHidden: true,
}).partial();

export type DatabaseRevisionForPatch = z.infer<typeof DatabaseRevisionForPatch>;

export const DatabaseRevisionForPatchAfterPublish =
  DatabaseRevisionForPatch.omit({
    selectedSchema: true,
    transformId: true,
  });

export type DatabaseRevisionForPatchAfterPublish = z.infer<
  typeof DatabaseRevisionForPatchAfterPublish
>;

export const DatabaseRevisions = z.object({
  databaseRevisions: z.array(DatabaseRevision),
});

export type DatabaseRevisions = z.infer<typeof DatabaseRevisions>;

export const getDatabaseRevisionNameOrDefault = ({
  revision,
  databaseName,
}: {
  revision: DatabaseRevision;
  databaseName: string;
}): string => {
  return revision.name ?? `${databaseName} - v${revision.sequence}`;
};
